import clsx from "clsx"

import { userColorByStatus } from "@constants/colorByStatus"

import styles from "./AvatarStatus.module.scss"
import { AvatarStatusProps } from "./AvatarStatus.types"

export default function AvatarStatus(props: AvatarStatusProps) {
    const { variant } = props
    const color = variant === "user" ? userColorByStatus[props.status] : props.color

    return (
        <div
            className={clsx(styles.base, styles[variant])}
            style={
                {
                    "--status-color": color,
                } as React.CSSProperties
            }
        />
    )
}
